import { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import ContributorAction from '../../referencial/components/contributor/actions/ContributorAction'
import CityAction from '../../referencial/components/city/actions/CityAction'
import ProductionUnitAction from '../actions/ProductionUnitAction'
import QualityAction from '../../quality/actions/QualityAction'
import ReferencialAction from '../../referencial/action/ReferencialAction'
import SectorAction from '../../referencial/components/sector/actions/SectorAction'
import StationAction from '../../station/actions/StationAction'
import UserAction from '../../administration/components/user/actions/UserAction'
import useProgressDispatch from '../../utils/customHook/useProgressDispatch'
import { STATION_TYPE_NAME } from '../../station/constants/StationConstants'
import { findStationType } from '../../utils/StationUtils'

const stationType = STATION_TYPE_NAME.productionUnit

// Référentiels communs aux écrans « toutes unités de production » (tableau de bord, gestion des volumes).
const useProductionUnitsData = () => {
    const {
        cities,
        contributors,
        productionUnits,
        productionUnitsAssociations,
        sandreCodes,
        sectors,
        status,
        userBookmarks,
    } = useSelector(store => ({
        cities: store.CityReducer.cities,
        contributors: store.ContributorReducer.contributors,
        productionUnits: store.ProductionUnitReducer.productionUnits,
        productionUnitsAssociations: store.ProductionUnitReducer.productionUnitsAssociations,
        sandreCodes: store.ReferencialReducer.sandreCodes,
        sectors: store.SectorReducer.sectors,
        status: store.QualityReducer.status,
        userBookmarks: store.UserReducer.userBookmarks,
    }), shallowEqual)

    const [unitsAssociationsLoaded, setUnitsAssociationsLoaded] = useState(false)

    const dispatch = useDispatch()

    const { isLoaded, progress } = useProgressDispatch(() => {
        const promises = !userBookmarks.length ? [UserAction.fetchBookmarks] : []
        const findedStationType = findStationType(stationType)
        const promisesContributorsLinks = findedStationType.code !== 9 ? [...promises, () => StationAction.fetchAllContributors(findedStationType.code)] : promises
        const promisesContributors = !contributors.length ? [...promisesContributorsLinks, ContributorAction.fetchContributors] : promisesContributorsLinks
        const promisesStatus = !status.length ? [...promisesContributors, QualityAction.fetchStatus] : promisesContributors
        const promisesSandreCodes = !sandreCodes.length ? [...promisesStatus, ReferencialAction.fetchSandreCodes] : promisesStatus
        const promisesCities = !cities.length ? [...promisesSandreCodes, CityAction.fetchCities] : promisesSandreCodes
        const promisesSectors = !sectors.length ? [...promisesCities, SectorAction.fetchSectors] : promisesCities
        const promisesProductionUnit = !productionUnits.length ? [...promisesSectors, ProductionUnitAction.fetchProductionUnits] : promisesSectors
        return promisesProductionUnit.map(p => dispatch(p()))
    }, [])

    useEffect(() => {
        if (productionUnits.length) {
            if (!productionUnitsAssociations.length) {
                dispatch(ProductionUnitAction.fetchAllProductionUnitsAssociations()).then(() => setUnitsAssociationsLoaded(true))
            } else {
                setUnitsAssociationsLoaded(true)
            }
        } else if (isLoaded) {
            setUnitsAssociationsLoaded(true)
        }
    }, [dispatch, productionUnits.length, productionUnitsAssociations.length, isLoaded])

    return {
        dataLoaded: isLoaded && unitsAssociationsLoaded,
        progress: progress * 0.9,
    }
}

export default useProductionUnitsData
